import { fetchJSON } from 'omni-ui';
const isLocalDev = !!document.body.querySelector('campaign-test-wrapper,omni-app-container');
export default class OmniAPI {
    #origin = 'prod';
    #ansid = window.AN?.sso?.session?.sid;
    #personId = window.AN?.sso?.user?.personId;
    constructor(env = 'prod') {
        /**
         * When a consumer of this package running in portal/omni, we can simply hit
         * the backend with the current location.origin. If running locally for
         * testing we need to fetch from the appropriate omni server.
         */
        let prefix = env;
        if (env === 'local')
            prefix = 'dev';
        if (env === 'prod')
            prefix = '';
        this.#origin = isLocalDev
            ? `https://${prefix}omni.annalect.com`
            : document.location.origin;
    }
    /**
     * @param personId the user's ID
     * @param ANsid the session ID
     */
    getClientPreferences(personId = this.#personId, ANsid = this.#ansid) {
        return fetchJSON(`${this.#origin}/api/preferences/clients/${personId}?ANsid=${ANsid}`, 
        /** @todo figure this out */
        undefined);
    }
    /**
     * @param personId - the user's ID
     * @param ansid - the session ID
     * @returns {Promise}
     */
    getTeamsPreferences(personId = this.#personId, ANsid = this.#ansid) {
        return fetchJSON(`${this.#origin}/api/preferences/teams/${personId}?ANsid=${ANsid}`, 
        /** @todo figure this out */
        undefined);
    }
}
//# sourceMappingURL=omni-api.js.map